export const PARTNER_CONTACT_TABLE = "partner-contacts"
export const PARTNER_CONTACT_TABLE_SCHEMA =
  "id, companyId, partnerId, companyOwner, syncId"
